import {Controller} from "stimulus"
import $ from 'jquery';
import {get} from '@rails/request.js'
import flatpickr from "flatpickr";
import {create_array_for_product} from "./b2b_controller";


export default class extends Controller {
    static targets = ["destinationsSelect", "dealerSelect", "contractSelect", "categorySelect", "fromDate", "toDate", "fromTime", "toTime", "pickupOffice", "dropoffOffice", "divTariffModality", "divSupplements", "tariffSelect", "modalitySelect", "driversSelect", "supplementInsuranceSelect", "divClient", "countrySelect", "agencyContinueBookingBtn"]

    connect() {
        // alert('Estamos en agency');
        // ------------step-wizard-------------
        /*$(document).ready(function () {
            $('.nav-tabs > li a[title]').tooltip();

            //Wizard
            $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                let target = $(e.target);

                if (target.parent().hasClass('disabled')) {
                    return false;
                }
            });

            $(".next-step").click(function (e) {
                let active = $('.wizard .nav-tabs li.active');
                active.next().removeClass('disabled');
                nextTab(active);
            });
            $(".prev-step").click(function (e) {
                let active = $('.wizard .nav-tabs li.active');
                prevTab(active);
            });
        });

        function nextTab(elem) {
            $(elem).next().find('a[data-toggle="tab"]').click();
        }
        function prevTab(elem) {
            $(elem).prev().find('a[data-toggle="tab"]').click();
        }


        $('.nav-tabs').on('click', 'li', function() {
            $('.nav-tabs li.active').removeClass('active');
            $(this).addClass('active');
        });*/
    }

    initialize() {
        let context = this;

        /* DESTINOS */
        if (this.hasDestinationsSelectTarget) {
            $(this.destinationsSelectTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione un destino",
                allowClear: true
            }).on('select2:select', function () {
                $(context.dealerSelectTarget).removeAttr('disabled');
                $(context.dealerSelectTarget).empty();
                $(context.contractSelectTarget).prop('disabled', true);
                $(context.contractSelectTarget).empty();
                $(context.categorySelectTarget).prop('disabled', true);
                $(context.categorySelectTarget).empty();
            }).on('select2:unselecting', function () {
                // console.info('unselecting destino');
                $(context.dealerSelectTarget).prop('disabled', true);
                $(context.dealerSelectTarget).empty();

                $(context.contractSelectTarget).prop('disabled', true);
                $(context.contractSelectTarget).empty();

                $(context.categorySelectTarget).prop('disabled', true);
                $(context.categorySelectTarget).empty();

                $('#agency_from')[0]._flatpickr?.clear();
                $(context.fromDateTarget).val('');
                $('#agency_to')[0]._flatpickr?.clear();
                $(context.toDateTarget).val('');
                $('#agency_from_time').val('');
                $(context.fromTimeTarget).val('');
                $('#agency_to_time').val('');
                $(context.toTimeTarget).val('');

                $(context.pickupOfficeTarget).prop('disabled', true);
                $(context.pickupOfficeTarget).empty();
                $(context.dropoffOfficeTarget).prop('disabled', true);
                $(context.dropoffOfficeTarget).empty();

                $(context.tariffSelectTarget).prop('disabled', true);
                $(context.tariffSelectTarget).empty();
                $(context.modalitySelectTarget).prop('disabled', true);
                $(context.modalitySelectTarget).empty();

                $(context.divTariffModalityTarget).css('display', 'none');
                $(context.divSupplementsTarget).css('display', 'none');
                $(context.driversSelectTarget).prop('disabled', true);
                $(context.supplementInsuranceSelectTarget).prop('disabled', true);

                $(context.divClientTarget).css('display', 'none');
            }).on('change.select2', () => {
                // console.info('change destino');
                if (!context.destinationsSelectTarget.selectedOptions[0].value.isEmpty()) {
                    context.getDealer();
                }
                if (context.destinationsSelectTarget.options.length === 1) {
                    $(context.dealerSelectTarget).removeAttr('disabled');
                    $(context.dealerSelectTarget).empty();
                    $(context.contractSelectTarget).prop('disabled', true);
                    $(context.contractSelectTarget).empty();
                    $(context.categorySelectTarget).prop('disabled', true);
                    $(context.categorySelectTarget).empty();

                    context.getDealer();
                }

                $(context.categorySelectTarget).prop('disabled', true);
                $(context.categorySelectTarget).empty();

                $('#agency_from')[0]._flatpickr?.clear();
                $(context.fromDateTarget).val('');
                $('#agency_to')[0]._flatpickr?.clear();
                $(context.toDateTarget).val('');
                $('#agency_from_time').val('');
                $(context.fromTimeTarget).val('');
                $('#agency_to_time').val('');
                $(context.toTimeTarget).val('');

                $(context.pickupOfficeTarget).prop('disabled', true);
                $(context.pickupOfficeTarget).empty();
                $(context.dropoffOfficeTarget).prop('disabled', true);
                $(context.dropoffOfficeTarget).empty();

                $(context.tariffSelectTarget).prop('disabled', true);
                $(context.tariffSelectTarget).empty();
                $(context.modalitySelectTarget).prop('disabled', true);
                $(context.modalitySelectTarget).empty();

                $(context.divTariffModalityTarget).css('display', 'none');
                $(context.divSupplementsTarget).css('display', 'none');
                $(context.driversSelectTarget).prop('disabled', true);
                $(context.supplementInsuranceSelectTarget).prop('disabled', true);
            });
        }

        /* PRESTATARIOS */
        if (this.hasDealerSelectTarget) {
            $(this.dealerSelectTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione una sucursal",
                allowClear: true
            }).on('change.select2', () => {
                // console.log('change dealer');

                $(context.contractSelectTarget).prop('disabled', true);
                $(context.contractSelectTarget).empty();

                $(context.categorySelectTarget).prop('disabled', true);
                $(context.categorySelectTarget).empty();

                $('#agency_from')[0]._flatpickr?.clear();
                $(context.fromDateTarget).val('');
                $('#agency_to')[0]._flatpickr?.clear();
                $(context.toDateTarget).val('');
                $('#agency_from_time').val('');
                $(context.fromTimeTarget).val('');
                $('#agency_to_time').val('');
                $(context.toTimeTarget).val('');

                $(context.pickupOfficeTarget).prop('disabled', true);
                $(context.pickupOfficeTarget).empty();
                $(context.dropoffOfficeTarget).prop('disabled', true);
                $(context.dropoffOfficeTarget).empty();

                $(context.tariffSelectTarget).prop('disabled', true);
                $(context.tariffSelectTarget).empty();
                $(context.modalitySelectTarget).prop('disabled', true);
                $(context.modalitySelectTarget).empty();

                $(context.divTariffModalityTarget).css('display', 'none');
                $(context.divSupplementsTarget).css('display', 'none');
                $(context.driversSelectTarget).prop('disabled', true);
                $(context.supplementInsuranceSelectTarget).prop('disabled', true);

                $(context.divClientTarget).css('display', 'none');

                if (this.dealerSelectTarget.options.length === 1) {
                    context.getContract();
                    $(context.dealerSelectTarget).removeAttr('disabled');
                    $(context.contractSelectTarget).removeAttr('disabled');
                    $(context.contractSelectTarget).empty();
                } else {
                    context.getContract();
                    $(this.dealerSelectTarget).removeAttr('disabled');
                }
            }).on('select2:select', function () {
                // console.log('select dealer');
                $(context.contractSelectTarget).removeAttr('disabled');
                $(context.contractSelectTarget).empty();
            }).on('select2:unselecting', function () {
                // console.log('unselecting dealer');

                $(context.contractSelectTarget).prop('disabled', true);
                $(context.contractSelectTarget).empty();

                $(context.categorySelectTarget).prop('disabled', true);
                $(context.categorySelectTarget).empty();

                $('#agency_from')[0]._flatpickr?.clear();
                $(context.fromDateTarget).val('');
                $('#agency_to')[0]._flatpickr?.clear();
                $(context.toDateTarget).val('');
                $('#agency_from_time').val('');
                $(context.fromTimeTarget).val('');
                $('#agency_to_time').val('');
                $(context.toTimeTarget).val('');

                $(context.pickupOfficeTarget).prop('disabled', true);
                $(context.pickupOfficeTarget).empty();
                $(context.dropoffOfficeTarget).prop('disabled', true);
                $(context.dropoffOfficeTarget).empty();

                $(context.tariffSelectTarget).prop('disabled', true);
                $(context.tariffSelectTarget).empty();
                $(context.modalitySelectTarget).prop('disabled', true);
                $(context.modalitySelectTarget).empty();

                $(context.divTariffModalityTarget).css('display', 'none');
                $(context.divSupplementsTarget).css('display', 'none');
                $(context.driversSelectTarget).prop('disabled', true);
                $(context.supplementInsuranceSelectTarget).prop('disabled', true);
            });
        }

        /* CONTRATOS */
        if (this.hasContractSelectTarget) {
            $(this.contractSelectTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione un contrato",
                allowClear: true
            }).on('change.select2', () => {
                // console.info('change contract');

                if (!context.contractSelectTarget.selectedOptions[0].value.isEmpty()) {
                    $(context.categorySelectTarget).removeAttr('disabled')
                    $(context.contractSelectTarget).removeAttr('disabled');
                    context.getCategory();
                }

                $(context.categorySelectTarget).prop('disabled', true);
                $(context.categorySelectTarget).empty();

                $('#agency_from')[0]._flatpickr?.clear();
                $(context.fromDateTarget).val('');
                $('#agency_to')[0]._flatpickr?.clear();
                $(context.toDateTarget).val('');
                $('#agency_from_time').val('');
                $(context.fromTimeTarget).val('');
                $('#agency_to_time').val('');
                $(context.toTimeTarget).val('');

                $(context.pickupOfficeTarget).prop('disabled', true);
                $(context.pickupOfficeTarget).empty();
                $(context.dropoffOfficeTarget).prop('disabled', true);
                $(context.dropoffOfficeTarget).empty();

                $(context.tariffSelectTarget).prop('disabled', true);
                $(context.tariffSelectTarget).empty();
                $(context.modalitySelectTarget).prop('disabled', true);
                $(context.modalitySelectTarget).empty();

                $(context.divTariffModalityTarget).css('display', 'none');
                $(context.divSupplementsTarget).css('display', 'none');
                $(context.driversSelectTarget).prop('disabled', true);
                $(context.supplementInsuranceSelectTarget).prop('disabled', true);
            }).on('select2:select', function () {
                // console.info('select contract');
                if (!context.contractSelectTarget.selectedOptions[0].value.isEmpty()) {
                    $(context.categorySelectTarget).removeAttr('disabled');
                    $(context.categorySelectTarget).empty();
                }
            }).on('select2:unselecting', function () {
                // console.info('unselecting contract');
                $(context.categorySelectTarget).prop('disabled', true);
                $(context.categorySelectTarget).empty();

                $('#agency_from')[0]._flatpickr?.clear();
                $(context.fromDateTarget).val('');
                $('#agency_to')[0]._flatpickr?.clear();
                $(context.toDateTarget).val('');
                $('#agency_from_time').val('');
                $(context.fromTimeTarget).val('');
                $('#agency_to_time').val('');
                $(context.toTimeTarget).val('');

                $(context.pickupOfficeTarget).prop('disabled', true);
                $(context.pickupOfficeTarget).empty();
                $(context.dropoffOfficeTarget).prop('disabled', true);
                $(context.dropoffOfficeTarget).empty();

                $(context.tariffSelectTarget).prop('disabled', true);
                $(context.tariffSelectTarget).empty();
                $(context.modalitySelectTarget).prop('disabled', true);
                $(context.modalitySelectTarget).empty();

                $(context.divTariffModalityTarget).css('display', 'none');
                $(context.divSupplementsTarget).css('display', 'none');
                $(context.driversSelectTarget).prop('disabled', true);
                $(context.supplementInsuranceSelectTarget).prop('disabled', true);

                $(context.divClientTarget).css('display', 'none');
            });
        }

        /* CATEGORIAS */
        if (this.hasCategorySelectTarget) {
            $(this.categorySelectTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione una categoría",
                allowClear: true
            }).on('change.select2', () => {
                // console.info('change category');
                if (this.categorySelectTarget.options.length === 1) {
                    /* nada aún */
                } else {
                    $(this.categorySelectTarget).removeAttr('disabled');
                }
            }).on('select2:select', function () {
                // console.info('select2 category');
                context.from_to_flatpickr();
                context.getTariff();
                context.getModality();

                $(context.divTariffModalityTarget).removeAttr('style');
                $(context.divSupplementsTarget).removeAttr('style');
                $(context.driversSelectTarget).removeAttr('disabled');
                $(context.supplementInsuranceSelectTarget).removeAttr('disabled');
                $(context.tariffSelectTarget).removeAttr('disabled');
                $(context.modalitySelectTarget).removeAttr('disabled');
            }).on('select2:unselecting', function () {
                // console.info('unselecting category');

                $('#agency_from')[0]._flatpickr?.clear();
                $(context.fromDateTarget).val('');
                $('#agency_to')[0]._flatpickr?.clear();
                $(context.toDateTarget).val('');
                $('#agency_from_time').val('');
                $(context.fromTimeTarget).val('');
                $('#agency_to_time').val('');
                $(context.toTimeTarget).val('');

                $(context.pickupOfficeTarget).prop('disabled', true);
                $(context.pickupOfficeTarget).empty();
                $(context.dropoffOfficeTarget).prop('disabled', true);
                $(context.dropoffOfficeTarget).empty();

                $(context.tariffSelectTarget).prop('disabled', true);
                $(context.tariffSelectTarget).empty();
                $(context.modalitySelectTarget).prop('disabled', true);
                $(context.modalitySelectTarget).empty();

                $(context.divTariffModalityTarget).css('display', 'none');
                $(context.divSupplementsTarget).css('display', 'none');
                $(context.driversSelectTarget).prop('disabled', true);
                $(context.supplementInsuranceSelectTarget).prop('disabled', true);

                $(context.divClientTarget).css('display', 'none');
            });
        }

        /* OFICINA DE RECOGIDA */
        if (this.hasPickupOfficeTarget) {
            $(this.pickupOfficeTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione una oficina",
                allowClear: true
            }).on('change.select2', () => {
                // console.info('change pickupoffice');
                context.getDropoffOffice();
                $(context.pickupOfficeTarget).removeAttr('disabled');

                if (context.pickupOfficeTarget.selectedOptions.length > 0) {
                    if (!context.pickupOfficeTarget.selectedOptions[0].value.isEmpty()) {
                        /* ErnePazzo para que la hora de entrega sea por los datos apertura y cierre de la oficina */
                        /*if (context.pickupOfficeTarget.selectedOptions[0].dataset.fullTime === 'true') {
                            let to_time = $(context.fromTimeTarget).val()
                            $('#agency_to_time').val(to_time);
                            $(context.toTimeTarget).val(to_time);
                        } else {
                            flatpickr("#agency_to_time", {
                                enableTime: true,
                                noCalendar: true,
                                dateFormat: "H:i",
                                altFormat: "H:i",
                                time_24hr: true,
                                minDate: context.pickupOfficeTarget.selectedOptions[0].dataset.openTime,
                                maxDate: context.pickupOfficeTarget.selectedOptions[0].dataset.closeTime,
                                locale: 'es',
                                disableMobile: "true",
                            })
                        }*/
                    }
                }
            }).on('select2:select', function () {
                // console.info('select2 pickupoffice');
                /*context.getDropoffOffice();*/
            }).on('select2:unselecting', function () {
                // console.info('unselecting pickupoffice');

                $('#agency_to_time').val('');
                $(context.toTimeTarget).val('');

                $(context.divClientTarget).css('display', 'none');
            });
        }

        /* OFICINA DE ENTREGA */
        if (this.hasDropoffOfficeTarget) {
            $(this.dropoffOfficeTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione una oficina",
                allowClear: true
            }).on('change.select2', () => {
                // console.info('change dropoffoffice');
                if (this.dropoffOfficeTarget.options.length === 1) {
                    /* nada aún */
                } else {
                    $(this.dropoffOfficeTarget).removeAttr('disabled');
                }
            }).on('select2:select', function () {
                // console.info('select2 dropoffoffice');

                if (context.dropoffOfficeTarget.selectedOptions.length > 0) {
                    if (!context.dropoffOfficeTarget.selectedOptions[0].value.isEmpty()) {
                        $(context.divClientTarget).removeAttr('style');
                    }
                }
            }).on('select2:unselecting', function () {
                // console.info('unselecting dropoffoffice');

                $(context.divClientTarget).css('display', 'none');
            });
        }

        /* TARIFA */
        if (this.hasTariffSelectTarget) {
            $(this.tariffSelectTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione una tarifa",
                allowClear: true
            }).on('change.select2', () => {
                // console.info('change tariff');
                if (this.tariffSelectTarget.options.length === 1) {
                    /* nada aún */
                } else {
                    $(this.tariffSelectTarget).removeAttr('disabled');
                }
            }).on('select2:select', function () {
                // console.info('select2 tariff');
            }).on('select2:unselecting', function () {
                // console.info('unselecting tariff');
            });
        }

        /* MODALIDAD */
        if (this.hasModalitySelectTarget) {
            $(this.modalitySelectTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione una modalidad",
                allowClear: true
            }).on('change.select2', () => {
                // console.info('change modality');
                if (context.modalitySelectTarget.options.length === 1) {
                } else {
                    $(context.modalitySelectTarget).removeAttr('disabled');
                }
            }).on('select2:select', function () {
                // console.info('select2 modality');
            }).on('select2:unselecting', function () {
                // console.info('unselecting modality');
            });
        }

        /* CHOFER ADICIONAL */
        if (this.hasDriversSelectTarget) {
            $(this.driversSelectTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione una opción",
                allowClear: true
            }).on('change.select2', () => {
                // console.info('change drivers');
                if (this.driversSelectTarget.options.length === 1) {
                    /* nada aún */
                } else {
                    $(this.driversSelectTarget).removeAttr('disabled');
                }
            }).on('select2:select', function () {
                // console.info('select2 drivers');
            }).on('select2:unselecting', function () {
                // console.info('unselecting drivers');
            });
        }

        /* SUPLEMENTO RESPONSABILIDAD ADICIONAL */
        if (this.hasSupplementInsuranceSelectTarget) {
            $(this.supplementInsuranceSelectTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione una opción",
                allowClear: true
            }).on('change.select2', () => {
                // console.info('change supplementInsuranceSelect');
                if (this.supplementInsuranceSelectTarget.options.length === 1) {
                    /* nada aún */
                } else {
                    $(this.supplementInsuranceSelectTarget).removeAttr('disabled');
                }
            }).on('select2:select', function () {
                // console.info('select2 supplementInsuranceSelect');
            }).on('select2:unselecting', function () {
                // console.info('unselecting supplementInsuranceSelect');
            });
        }

        /* PAÍS */
        if (this.hasCountrySelectTarget) {
            $(this.countrySelectTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione un país",
                allowClear: true
            }).on('change.select2', () => {
                // console.info('change country');
            }).on('select2:select', function () {
                // console.info('select2 country');
            }).on('select2:unselecting', function () {
                // console.info('unselecting country');
            });
        }
    }

    /* Para cuando se da click pero estas sin loguear */
    isLogin(r) {
        if (r.responseText && typeof r.responseText.then === 'function') {
            r.responseText.then((v) => {
                let value = v.trim();

                if (value.includes("login")) {
                    window.location.href = v.trim();
                }
            })
        }
        if (r.response && typeof r.response.then === 'function') {
            r.response.then((v) => {
                let value = v.trim();

                if (value.includes("login")) {
                    window.location.href = v.trim();
                }
            })
        } else {
            if (r.response.url.includes("login")) {
                window.location.href = r.response.url;
            }
        }
    }

    /* De Destination a Dealer */
    getDealer() {
        get(`/agency/get_dealers`, {
            query: {
                destination_id: this.destinationsSelectTarget.selectedOptions[0].value,
                target: this.dealerSelectTarget.id
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.isLogin(r);
            this.setDealerData()
        });
    }

    setDealerData() {
        setTimeout(() => {
            if (this.dealerSelectTarget.options.length === 1) {
                $(this.dealerSelectTarget).trigger({
                    type: 'change.select2'
                });
            }/* else {
                $(this.dealerSelectTarget).removeAttr('disabled');
                $(this.contractSelectTarget).val("");
                $(this.contractSelectTarget).prop('disabled', true);
                $(this.categorySelectTarget).val("");
                $(this.categorySelectTarget).prop('disabled', true);
            }*/
        }, 500)
    }


    /* De Dealer a Contract */
    getContract() {
        get(`/agency/get_contracts`, {
            query: {
                target: this.contractSelectTarget.id
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.isLogin(r);
            this.setContractData()
        })
    }

    setContractData() {
        setTimeout(() => {
            if (this.contractSelectTarget.options.length === 1) {
                $(this.contractSelectTarget).trigger({
                    type: 'change.select2'
                });
            } else {
                $(this.categorySelectTarget).val("");
                $(this.categorySelectTarget).prop('disabled', true);
            }
        }, 500)
    }

    /* De Contract a Category */
    getCategory() {
        get(`/agency/get_categories`, {
            query: {
                target: this.categorySelectTarget.id
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.isLogin(r);
            this.setCategoryData()
        })
    }

    setCategoryData() {
        setTimeout(() => {
            if (this.categorySelectTarget.options.length === 1) {
                $(this.categorySelectTarget).trigger({
                    type: 'change.select2'
                });
            } else {
                $(this.categorySelectTarget).removeAttr('disabled');
            }
        }, 500)
    }

    from_to_flatpickr() {
        // console.info('from_to_flatpickr');

        let category_option = $(this.categorySelectTarget.selectedOptions[0]);
        let min_length_reservation = category_option.data('min-length-reservation');
        let max_length_reservation = category_option.data('max-length-reservation');

        flatpickr("#agency_from", {
            altInput: true,
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d",
            /*disable: date_disabled,*/
            disableMobile: "true",
            /*minDate: new Date().fp_incr(parseInt(category_details.reservation_time)),*/
            minDate: new Date().fp_incr(min_length_reservation),
            /*maxDate: new Date().fp_incr(31),*/
            locale: 'es'
        });
        flatpickr("#agency_from_time", {
            enableTime: true,
            noCalendar: true,
            dateFormat: "H:i",
            altFormat: "H:i",
            time_24hr: true,
            locale: 'es',
            disableMobile: "true",
        })

        $('#agency_from').on('change', (e) => {
            console.warn('Cambié el FROM y va a empezar el TO');
            let agency_from_value = e.target.value;

            if (agency_from_value !== '') {
                $(this.fromDateTarget).val(agency_from_value);

                let fecha_min = new Date(agency_from_value);
                fecha_min.setDate(fecha_min.getDate() + min_length_reservation); // Sumamos 3 días
                let fecha_max = new Date(agency_from_value);
                fecha_max.setDate(fecha_max.getDate() + max_length_reservation); // Sumamos 3 días

                flatpickr("#agency_to", {
                    altInput: true,
                    altFormat: "d-m-Y",
                    dateFormat: "Y-m-d",
                    /*disable: date_disabled,*/
                    disableMobile: "true",
                    /*minDate: new Date().fp_incr(parseInt(category_details.reservation_time)),*/
                    minDate: fecha_min.toISOString().split('T')[0],
                    maxDate: fecha_max.toISOString().split('T')[0],
                    locale: 'es'
                });
            }
        })
        $('#agency_to').on('change', (e) => {
            console.warn('Cambié el TO');
            $(this.toDateTarget).val(e.target.value);

            let to_time = $(this.fromTimeTarget).val()
            $('#agency_to_time').val(to_time);
            $(this.toTimeTarget).val(to_time);

            /* ErnePazzo o hago aqui la llamada para saber que oficinas existen en ese dealer y así manejar las horas o primero oficinas y despues fecha y hora */
        })

        $('#agency_from_time').on('change', (e) => {
            let from_time = e.target.value;
            $(this.fromTimeTarget).val(from_time);
            /*if (sessionStorage.getItem('use_same_hours') === 'true') {
            let agency_to_time = $('#agency_to_time');
            agency_to_time[0].value = e.target.value;
            /*}*/

            this.getPickupOffice();
        })

        $('#agency_to_time').on('change', (e) => {
            let to_time = e.target.value;
            $(this.toTimeTarget).val(to_time);

            /* this.getPickupOffice(); */
        })
    }

    /* De Category a PickupOffice */
    getPickupOffice() {
        get(`/agency/get_pickup_office`, {
            query: {
                destination_id: this.destinationsSelectTarget.selectedOptions[0].value,
                dealer_id: this.dealerSelectTarget.selectedOptions[0].value,
                from_time: $(this.fromTimeTarget).val(),
                target: this.pickupOfficeTarget.id
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.isLogin(r);
            this.setPickupOfficeData()
        })
    }

    setPickupOfficeData() {
        setTimeout(() => {
            if (this.pickupOfficeTarget.options.length === 1) {
                $(this.pickupOfficeTarget).trigger({
                    type: 'change.select2'
                });
            } else {
                $(this.pickupOfficeTarget).removeAttr('disabled');
            }
        }, 500)
    }

    /* De PickupOffice a DropoffOffice */
    getDropoffOffice() {
        get(`/agency/get_dropoff_office`, {
            query: {
                target: this.dropoffOfficeTarget.id
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.isLogin(r);
            this.setDropoffOfficeData()
        })
    }

    setDropoffOfficeData() {
        setTimeout(() => {
            if (this.dropoffOfficeTarget.options.length === 1) {
                $(this.dropoffOfficeTarget).trigger({
                    type: 'change.select2'
                });
            } else {
                $(this.dropoffOfficeTarget).removeAttr('disabled');
            }
        }, 500)
    }

    /* De Category a Tariff */
    getTariff() {
        get(`/agency/get_tariffs`, {
            query: {
                contract_id: this.contractSelectTarget.selectedOptions[0].value,
                target: this.tariffSelectTarget.id
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.isLogin(r);
            this.setTariffData()
        })
    }

    setTariffData() {
        setTimeout(() => {
            if (this.tariffSelectTarget.options.length === 1) {
                $(this.tariffSelectTarget).trigger({
                    type: 'change.select2'
                });
            } else {
                $(this.tariffSelectTarget).removeAttr('disabled');
            }
        }, 500)
    }

    /* De Category a Modality */
    getModality() {
        get(`/agency/get_modalities`, {
            query: {
                product_id: this.categorySelectTarget.selectedOptions[0].value,
                target: this.modalitySelectTarget.id
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.isLogin(r);
            this.setModalityData()
        })
    }

    setModalityData() {
        setTimeout(() => {
            if (this.modalitySelectTarget.options.length === 1) {
                $(this.modalitySelectTarget).trigger({
                    type: 'change.select2'
                });
            } else {
                $(this.modalitySelectTarget).removeAttr('disabled');
            }
        }, 500)
    }


    open_tree(e) {
        e.target.parentElement.querySelector(".nested-bl").classList.toggle("active-bl");
        e.target.classList.toggle("caret-down-bl");
    }

    validate_emails(e) {
        let value = $.trim(e.target.value);

        let emails = value.split(',').map((email) => {
            return $.trim(email);
        }).filter((email) => {
            return email !== '';
        });

        let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
        let helper_email_error = [];
        let isValid_emails = [];
        emails.map(email => {
            if (emailRegex.test(email)) {
                isValid_emails.push(true);
            } else {
                helper_email_error.push(email);
                isValid_emails.push(false);
            }
        })
        /*let isValid = emails.every(function (email) {
            if (emailRegex.test(email)) {
                return true;
            } else {
                helper_email_error.push(email);
                return false;
            }

        });*/

        let isValid = isValid_emails.every(valor => {
            return valor === true;
        })

        if (!isValid) {
            $(`#${e.target.dataset.validate}`).attr('disabled', 'disabled');
            e.target.classList.add('is-invalid');
            $(`#${e.target.dataset.helper}`).text(`Correos que no cumplen con los requisitos: ${helper_email_error.join(', ')}`)
        } else {
            $(`#${e.target.dataset.validate}`).removeAttr('disabled');
            e.target.classList.remove('is-invalid');
            $(`#${e.target.dataset.helper}`).text('')
            helper_email_error = []
            // console.log(e.target);
        }
    }

    validate_date(e) {
        let value = $.trim(e.target.value);

        if (value === '') {
            $(`#${e.target.dataset.validate}`).attr('disabled', 'disabled')
        } else {
            $(`#${e.target.dataset.validate}`).removeAttr('disabled')
        }
    }
}